import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { RoleProvider } from './RoleContext';
import { ThemeProvider } from './context/ThemeContext';
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root'));
// Note: StrictMode disabled due to Firebase 11.x bug with listener cleanup
// Re-enable once Firebase fixes the issue or after downgrading Firebase
root.render(
  <HelmetProvider>
    <ThemeProvider>
      <AuthProvider>
        <RoleProvider>
          <App />
        </RoleProvider>
      </AuthProvider>
    </ThemeProvider>
  </HelmetProvider>
);

reportWebVitals();
